import NavyTopbarModernThumbnailPath from '../../../assets/template-thumbnails/topbar-center/navy-modern-topbar-centered-template-thumbnail.png';

const NavyTopbarModernTemplate = {
    id: 'navy-modern-topbar-template',
    name: 'Navy Modern',
    category: 'Topbar Modern',
    settings: {
      layoutId: 'topbar-centered',
      designId: 'custom',
      style: 'tech',
      background: 'blank',
      barStyleId: 'bars',
      specialEffectId: 'timeline',
      customColors: {
        primary: "#0D47A1",
        secondary: "#102027",
        tertiary: "#1565C0",
        quaternary: "#37474F",
        accent1: "#1E88E5",
        accent2: "#0277BD",
        accent3: "#01579B",
        accent4: "#0D47A1",
        accent5: "#1A237E",
        accent6: "#283593",
        accent7: "#90CAF9",
        accent8: "#FFFFFF",
        text: "#102027",
        textSecondary: "#37474F",
        background: "#FFFFFF",
        sidebarBackground: "rgba(13, 71, 161, 1)",
        border: "rgba(13, 71, 161, 1)",
        sidebarPrimary: "rgba(255, 255, 255, 1)",
        sidebarText: "rgba(255, 255, 255, 1)"
      },
      typography: {
        cvTitle: { fontSize: 24, lineHeight: 1.4, fontFamily: "'Roboto', sans-serif" },
        sectionTitle: { fontSize: 12, lineHeight: 1.2, fontFamily: "'Roboto', sans-serif" },
        body: { fontSize: 10, lineHeight: 1, fontFamily: "'Roboto', sans-serif" },
        smallText: { fontSize: 8, lineHeight: 1.5, fontFamily: "'Roboto', sans-serif" },
      },
    },
    thumbnail: NavyTopbarModernThumbnailPath
  };

export default NavyTopbarModernTemplate; 